import {ReactElement} from "react";
import VZAlert from "../VZAlert";
import {Anchor} from "@zendeskgarden/react-buttons";
import {Paragraph} from "@zendeskgarden/react-notifications";


export interface VZAlertNoUnitTypesProps {
    userIsAdmin: boolean;
}

export default function VZAlertNoUnitTypes({userIsAdmin}: VZAlertNoUnitTypesProps): ReactElement {
    return (
        <VZAlert
            title={"No Unit Types Found"}
            message={"It looks like there are no Unit Types configured for this property."}
            alertType={"warning"}
            action={
                <>
                    {userIsAdmin ?
                        <Anchor
                            isExternal={true}
                            href={"/settings/unit-type-management"}
                            target="_blank"
                        >
                            Unit Type Management
                        </Anchor>
                        :
                        <Paragraph>Please contact your administrator for more information.</Paragraph>
                    }
                </>
            }
        />
    );
}